import React from 'react'
import Check from '@shared/svg/Check.svg'

import { reasonList } from '../../../../data/referral-partners'

import styles from './style.module.scss'

export const View = () => (
	<ul className={styles.reasonList}>
		{reasonList.map((r, idx) => (
			<li key={idx} className={styles.reasonItem}>
				<Check className={styles.svg} />
				<span className={styles.text}>{r}</span>
			</li>
		))}
	</ul>
)
